import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IDropdown, ILead } from "../../models/BaseModel";
import { Fetch, } from "../../shared/Fetch";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

interface ILeadHistory {
    id: number,
    leadId: number,
    statusId: number,
    statusName: string,
    isLeadActive: boolean,
    updatedBy: string,
    comment: string,
    createdAt: number
}

const schema = yup.object({
});

export const NoOfPlans = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], loading: false } as { data: ILeadHistory[], loading: boolean });
    const [renew, setRenew] = useState({ id: 0, open: false } as { id: number, open: boolean });
    const [plan, setPlan] = useState<IDropdown[]>();



    const { control, handleSubmit, formState: { errors }, reset } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });


    useEffect(() => {
        if (props.singleData.id && props.open) loadTableData();
    }, [props.singleData.id, props.open]);

    const loadTableData = async () => {
        console.log(props.singleData);
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`customer/getNoOfPlan/${props.singleData.contact_ID}`, "GET", null, null, props.toast);
        if (response) {
            const data: { customerAttachPlans: ILeadHistory[] } = await response.json();
            setTableData({ data: data.customerAttachPlans, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const createdAtBody = (rowData: any) => {
        return (
            <span>{rowData.created_at ? format(new Date(rowData.created_at+"Z"), 'dd/MM/yyyy hh:mm a') : '-'}</span>
        );
    }

    const expirdateAtBody = (rowData: any) => {
        return (
            <span>{rowData.expiry_date ? format(new Date(rowData.expiry_date), 'dd/MM/yyyy hh:mm a') : '-'}</span>
        );
    }

    const showRenewDialog = (rowData: any) => {
        setRenew({ id: rowData.id, open: true });
    }

    // if plan expired then show red tag else green tag 
    const showcustomerName = (rowData: any) => {
        return (
            <>
                <Tag className="mr-2 text-lg" value={rowData.customer_Name} severity={rowData.is_Expired ? 'danger' : 'info'}></Tag>
                {/* {rowData.is_Expired && <Button icon="pi pi-sitemap" className='p-button-info p-button-text p-0' onClick={() => { showRenewDialog(rowData) }} ></Button>} */}
            </>
        );
    }

    const loadPlan = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) {
            setPlan(await response.json());
        }
    }

    const saveToDB = async (body: ILead) => {
        console.log(renew)
        const response = await Fetch(`customer${renew.id ? '/' + renew.id : ''}`, "PUT", body, null, props.toast);
        if (response) {
            const resData = await response.json();
            // setRenew({ id: 0, open: false });
            props.toast.current.show({ severity: 'success', detail: resData.message, life: 3000 });
        }
    }

    useEffect(() => {
        loadPlan();
    }, []);

    function onSubmit(data: ILead) {
        console.log(data)
        saveToDB(data);
    }

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={`No. Of Plans (${props.singleData.contactName} | ${props.singleData.contactContact})`} modal className="p-fluid" onHide={props.hideDialog}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows scrollHeight="50vh"
                    value={tableData.data}
                    loading={tableData.loading}
                >
                    <Column field="customer_Name" header="Customer Name" body={showcustomerName} sortable></Column>
                    <Column field="plan_Name" header="Plan Name" sortable></Column>
                    <Column field="plan_Duration" header="Plan Duration" sortable></Column>
                    <Column field="plan_Cost" header="Plan Cost" sortable></Column>
                    <Column field="created_by" header="created_by" sortable></Column>
                    <Column field="created_at" header="Plan Date" body={createdAtBody} sortable></Column>
                    <Column field="expiry_date" header="Expiry Date" body={expirdateAtBody} sortable></Column>

                </DataTable>
                <ConfirmDialog />
            </Dialog>
            <Dialog visible={renew.open} style={{ width: '20vw' }} header={`Renew Device`} modal className="p-fluid" onHide={() => { setRenew({ id: 0, open: false }) }}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                        <JVDropdown column={1} required label="Select Plan" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Status" />
                        <Button label="Renew" icon="pi pi-check" className="p-button-success" />
                    </div>
                </form>

            </Dialog>
        </>
    );
}
